import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import '../ai.scss';

interface Props {
	content: string;
}

const AiMessageContent: React.FC<Props> = ({ content }) => {
	if (!content?.trim()) return null;

	return (
		<div className="ai-message__content">
			<ReactMarkdown
				remarkPlugins={[remarkGfm]}
				components={{
					table: ({ children }) => (
						<div className="ai-message__table-wrap">
							<table className="ai-message__table">{children}</table>
						</div>
					)
				}}
			>
				{content}
			</ReactMarkdown>
		</div>
	);
};

export default AiMessageContent;
